import React, { useContext } from "react";
import ThemeContext from "~/contexts/ThemeContext";

type ChevronLeftProps = {
  className?: string;
  color?: string;
};

const ChevronLeft: React.FC<ChevronLeftProps> = ({ className, color }) => {
  const { template } = useContext(ThemeContext);
  const iconColor = color || template.global.icon.colour;

  return (
    <svg
      className={className}
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.625 6.25L9.375 12.5L15.625 18.75"
        stroke={iconColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ChevronLeft;
